/**
 * Мелкие проверки wire-ответов для декодеров фич. Тип TypeScript ответ не
 * проверяет (D-056): неожиданная форма — это ошибка `invalid-response`, а не
 * пустой экран. Тексты сообщений идут в `TransportError.message` для отчёта.
 */
export function fail(message: string): never {
  throw new Error(message)
}

export function record(value: unknown, field: string): Record<string, unknown> {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) fail(`${field} — не объект`)
  return value as Record<string, unknown>
}

export function text(value: unknown, field: string): string {
  return typeof value === 'string' && value.trim() !== '' ? value : fail(`поле ${field} — не строка`)
}

/** Строка, которой может не быть: `null`/отсутствие — `null`. */
export function optionalText(value: unknown, field: string): string | null {
  if (value === null || value === undefined) return null
  return typeof value === 'string' ? value : fail(`поле ${field} — не строка`)
}

export function flag(value: unknown, field: string): boolean {
  return typeof value === 'boolean' ? value : fail(`поле ${field} — не логическое`)
}

export function integer(value: unknown, field: string): number {
  return typeof value === 'number' && Number.isFinite(value) ? value : fail(`поле ${field} — не число`)
}

export function optionalInteger(value: unknown, field: string): number | null {
  if (value === null || value === undefined) return null
  return integer(value, field)
}

export function list<T>(value: unknown, field: string, item: (raw: unknown, name: string) => T): T[] {
  if (!Array.isArray(value)) fail(`поле ${field} — не массив`)
  return value.map((entry: unknown, index) => item(entry, `${field}[${index}]`))
}

export function textList(value: unknown, field: string): string[] {
  return list(value, field, (entry, name) => (typeof entry === 'string' ? entry : fail(`${name} — не строка`)))
}

export function textMap(value: unknown, field: string): Record<string, string> {
  const source = record(value, field)
  const result: Record<string, string> = {}
  for (const [key, entry] of Object.entries(source)) {
    result[key] = typeof entry === 'string' ? entry : fail(`${field}.${key} — не строка`)
  }
  return result
}
